import React, { useState } from "react";
import { useQuery, useQueryClient } from "react-query"
import ReactTooltip from 'react-tooltip'
import { useSnackbar } from "notistack"

import { Row } from "components/Layout";
import Image from "components/Image";
import FilterAndSearch from "components/FilterAndSearch";
import NTMTable from "components/Table/NTMTable";
import PageWithModal from "components/Page/PageWithModal";
import DeviceQrModal from "components/Modal/DeviceQrModal";
import DeviceTypeModal from "components/Modal/DeviceTypeModal";
import EditLabelModal from "components/Modal/EditLabelModal";
import { get, getErrorMessage, post, DEVICES } from "service/Client"
import { projects } from "../../constants"
import { downloadIcon, downloadIcon_over, editIcon, editIcon_over } from "img/icons";


export default function DevicesManagerPage() {

	let [selected, setSelected] = useState(null)
	let [search, setSearch] = useState(null)
	const [isLabelModalOpen, setLabelModalOpen] = useState(false)
	const [isTypeModalOpen, setTypeModalOpen] = useState(false)
	const [isQrModalOpen, setQrModalOpen] = useState(false)
	const [managedDevice, setManagedDevice] = useState()

	const { enqueueSnackbar } = useSnackbar()
	let queryClient = useQueryClient()

	let { isLoading, data, error } = useQuery('devices', () => get('devices'))

	function changeLabel(label) {
		post(`${DEVICES}/${managedDevice.deviceId}/label`, {body: label, headers: {"Content-Type": "text/plain"}})
			.then(() => queryClient.invalidateQueries('devices'))
			.catch(showError)
		setLabelModalOpen(false)
	}

	function changeType(projectTypeId) {
		post(`${DEVICES}/${managedDevice.deviceId}/projectType`, {
			params: { projectTypeId },
		})
			.then(() => queryClient.invalidateQueries('devices'))
			.catch(showError);
		setTypeModalOpen(false)
	}

	function showError(e) {
		enqueueSnackbar(getErrorMessage(e), { variant: "error" })
	}


	if (isLoading) data = []

	if (selected) {
		let selProjectType = projects.types.find(r => r.name === selected)
		data = data.filter(d => d.projectTypeId === selProjectType.id)
	}

	if (search) {
		search = search.toLocaleLowerCase()
		data = data.filter(
			d => (d.deviceId && d.deviceId.toLocaleLowerCase().includes(search)) ||
				(d.label && d.label.toLocaleLowerCase().includes(search)) ||
				(d.projectName && d.projectName.toLocaleLowerCase().includes(search))
		)
	}

	return (
		<PageWithModal
			error={error}
			clear={() => null}
		>
			<FilterAndSearch
				filter={projects.types.map(r => r.name)}
				onFilter={(selected) => setSelected(selected)}
				onSearch={search => setSearch(search)}
				addElement={() => null}
				selected={selected}
			/>
			<Row>
				<NTMTable
					header={[
						{
							Header: "ID",
							accessor: 'id',
						},
						{
							Header: "Seriale Sigfox",
							accessor: 'deviceId'
						},
						{
							Header: "Label",
							accessor: 'label',
							Cell: props => (
								<Row style={{ justifyContent: "space-evenly" }}>
									<ReactTooltip effect='solid' />
									<div>{props.original.label}</div>
									<div data-tip="Modifica">
										<Image
											src={editIcon}
											hover={editIcon_over}
											onClick={() => { setLabelModalOpen(true); setManagedDevice(props.original) }}
										/>
									</div>
								</Row>
							)
						},
						{
							Header: "Tipo",
							accessor: 'projectTypeName',
							Cell: props => (
								<Row style={{ justifyContent: "space-evenly" }}>
									<ReactTooltip effect='solid' />
									<div>{props.original.projectTypeName}</div>
									{!props.original.projectId && ( // modifica del tipo progetto consentita solo se dispositivo non assegnato
										<div data-tip="Modifica">
											<Image
												src={editIcon}
												hover={editIcon_over}
												onClick={() => { setTypeModalOpen(true); setManagedDevice(props.original) }}
											/>
										</div>
									)}
								</Row>
							)
						},
						{
							Header: "Progetto",
							accessor: 'projectName'
						},
						{
							Cell: props =>
								<Row style={{ justifyContent: "space-evenly" }}>
									<ReactTooltip effect='solid' />
									<div data-tip="Qr code">
										<Image
											src={downloadIcon}
											hover={downloadIcon_over}
											onClick={() => { setQrModalOpen(true); setManagedDevice(props.original) }}
										/>
									</div>
								</Row>
						}
					]}
					body={data}
					defaultPageSize={10}
				/>
			</Row>

			<EditLabelModal
				isOpen={isLabelModalOpen}
				onClose={() => setLabelModalOpen(false)}
				onSubmit={changeLabel}
			/>
			<DeviceTypeModal
				isOpen={isTypeModalOpen}
				onClose={() => setTypeModalOpen(false)}
				onSubmit={changeType}
				initialValue={managedDevice?.projectTypeId}
			/>
			<DeviceQrModal
				isOpen={isQrModalOpen}
				onClose={() => setQrModalOpen(false)}
				device={managedDevice}
			/>
			{alert}
		</PageWithModal>
	);
}

